import React, { useState } from 'react';
import { axiosInstance } from '../App';
import { toast } from 'sonner';
import { X } from 'lucide-react';
import './AddQualificationModal.css';

const AddQualificationModal = ({ permitId, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    due_date: '',
    completed: false,
    completed_date: '',
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        due_date: new Date(formData.due_date).toISOString(),
        completed: formData.completed,
        completed_date: formData.completed && formData.completed_date
          ? new Date(formData.completed_date).toISOString()
          : null,
      };

      await axiosInstance.post(`/permits/${permitId}/qualifications`, payload);
      onSuccess();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to add qualification');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" data-testid="add-qualification-modal">
      <div className="modal-backdrop" onClick={onClose}></div>
      <div className="modal-content">
        <div className="modal-header">
          <h2 data-testid="modal-title">Add Past Qualification</h2>
          <button
            className="modal-close-btn"
            onClick={onClose}
            data-testid="modal-close-btn"
          >
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="qual-form" data-testid="qual-form">
          <div className="form-group">
            <label className="label">Qualification Due Date</label>
            <input
              type="date"
              name="due_date"
              className="input-field"
              value={formData.due_date}
              onChange={handleInputChange}
              required
              data-testid="due-date-input"
            />
            <p className="field-hint">
              Enter the original due date for this qualification
            </p>
          </div>

          <div className="form-group checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="completed"
                checked={formData.completed}
                onChange={handleInputChange}
                data-testid="completed-checkbox"
              />
              <span>This qualification was already completed</span>
            </label>
          </div>

          {formData.completed && (
            <div className="form-group">
              <label className="label">Completion Date</label>
              <input
                type="date"
                name="completed_date"
                className="input-field"
                value={formData.completed_date}
                onChange={handleInputChange}
                required
                data-testid="completed-date-input"
              />
            </div>
          )}

          <div className="info-box">
            <p>
              <strong>Note:</strong> Add past qualifications to maintain a complete
              history. Future qualifications will be automatically calculated from your
              permit issue date.
            </p>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="btn-outline"
              onClick={onClose}
              data-testid="cancel-btn"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={loading}
              data-testid="submit-btn"
            >
              {loading ? 'Adding...' : 'Add Qualification'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddQualificationModal;